<template>
    <v-col cols="12" xl="2" lg="3"  md="6"  id="metric-bar-b2b" class="box-container">
        <v-col cols="12" class="metric-title">
            <div class="d-flex flex-row">
                <div style="width: 90%;">
                    <span class="card-title" :title="metricInformation.title_graphic">{{metricInformation.title_graphic}}</span>
                </div>
                <div style="width: 10%;">
                    <span class="icon-info" @mouseleave="showBudget = false" @mouseover="showBudget = true" v-show="metricInformation.option.information">
                        <img src="/images/_SVGs/info.svg" onload="SVGInject(this)" width="20" height="20" />
                    </span>
                </div>
            </div>
        </v-col>
        <v-col cols="12" class="box-metric d-flex flex-column align-items-center">
            <div class="d-flex flex-row align-items-center grid-row-2"  v-for="(x, index) in metricInformation.option.x" :key="index">
                <div class="text-center">
                    <span>{{metricInformation.option.y[index]}} {{getType(metricInformation.option.myGarageIndicatorId)}}</span>
                    <span class="span-percentual" v-if="metricInformation.option.y1">
                        {{metricInformation.option.y1[index]}}
                    </span>
                    <p style="margin-bottom: 0px">{{metricInformation.option.x[index]}}</p>
                </div>
            </div>
        </v-col>
        <v-card v-show="showBudget" class="card-info">
            <p>{{metricInformation.title_graphic}}</p>
            <div class="table-tooltip-info-metrics">
                <table>
                    <tr>
                        <td class="subinfo-info-tooltip-metrics">{{metricInformation.option.information}}</td>
                    </tr>
                </table>
            </div>
        </v-card>
    </v-col>
</template>

<script>
    const myGarageIndicator = {
        TOTAL_ORDER: 1,
        TOTAL_ORDER_APPROVED: 2,
        TOTAL_ORDER_REPROVED: 3,
        TOTAL_ORDER_SAVE: 4,
        SEARCH_BUDGET: 5,
        ESTIMATED_QTD: 6,
        ESTIMATED_VALUE: 7,
        TYPE_OPERATION: 8,
        HOURS: 9,
        YEAR: 10,
    }
    export default {
        props: {
            metricInformation: Array | Object
        },
        data(){
            return {
                showBudget: false,
            }
        },
        methods: {
            getType(id){
                if(id == myGarageIndicator.HOURS){
                    return 'h'
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '@sass/_variables.scss';
    .card-title {
        width: 95%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 0;
    }

    #metric-bar-b2b {
        .span-percentual{
            font-size: 15px !important;
            margin-left: 3px;
            font-weight: 400 !important;
        }
        .icon-info {
            margin-top: 2px;
            margin-right: 2px;
            display: flex;
            justify-content: flex-end;
        }
        .box-container {
            position: relative;
        }

        .metric-title {
            background-color: var(--v-primary-base);
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            text-align: center;
            padding: 3px;
            span {
                color: white;
                font-size: 11px;
                text-transform: uppercase;
            }
            i {
                color: white;
                cursor: pointer;
            }
        }

        .box-metric {
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #4B4849;
            height: 210px;
            span {
                color: #4B4849;
                letter-spacing: 0px;
                font-size: 30px;
                font-weight: 600;
            }

            p {
                color: #4B4849;
                letter-spacing: 0px;
                font-size: 16px;
                font-weight: 500;
            }
        }

        .box-metric-graphic {
            position: relative;
            border-bottom: 2px solid #4B4849;
            height: 210px;
            padding: 0;
        }

        .card-info {
            position: absolute;
            top: 50px;
            right: 0px;
            bottom: auto;
            width: 200px;
            z-index: 999;

            p {
                background-color: #D6D6D6;
                text-align: center;
                font-size: 14px;
                border-bottom: 1px solid #D6D6D6;
                color: #4B4849;
                padding: 5px;
            }

            .table-tooltip-info-metrics {
                margin-bottom: 16px;
                table {
                    .subinfo-info-tooltip-metrics {
                        font-size: 12px;
                        letter-spacing: 0px;
                        color: #4B4849;
                        opacity: 1;
                        padding-left: 10px;
                        padding-right: 5px;
                    }
                }
            }
        }
        .grid-row-2{
            flex: 2;
            flex-wrap: wrap;
            justify-content: center;
        }
    }
</style>
